import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { CalculatorIcon, Menu, X, LogIn, UserPlus, UserCircle } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';
import logo from '../assets/logo.svg';
import { useState, useEffect } from 'react';

const Navbar = () => {
  const { user } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
      if (window.innerWidth >= 768) {
        setIsMenuOpen(false);
      }
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const handleQuickEstimate = () => {
    if (location.pathname === '/quick-estimate') {
      navigate('/quick-estimate');
    } else {
      navigate('/quick-estimate');
    }
  };

  const NavItems = () => (
    <div className={`flex ${windowWidth < 768 ? 'flex-col space-y-3' : 'space-x-4'}`}>
      <button
        onClick={handleQuickEstimate}
        className="btn btn-secondary flex items-center justify-center"
        style={{ fontSize: 13, padding: '6px 14px' }}
      >
        <CalculatorIcon className="h-4 w-4 mr-2" />
        Estimation rapide
      </button>
      {user && (
        <Link
          to="/estimation/nouvelle"
          className="btn bg-orange-500 hover:bg-orange-600 text-white flex items-center justify-center"
          style={{ fontSize: 13, padding: '6px 14px' }}
        >
          Estimation détaillée
        </Link>
      )}
    </div>
  );

  return (
    <nav className="bg-gradient-primary shadow-md z-50 h-12 shrink-0">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between h-12">
          {/* Logo */}
          <div className="flex items-center">
            <Link to="/" className="flex items-center hover:opacity-90">
              <img src={logo} alt="SimulReno" height="28" style={{ display: 'block' }} />
            </Link>
          </div>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-4">
            <NavItems />
            {user ? (
              <Link
                to="/dashboard"
                className="w-8 h-8 flex items-center justify-center rounded-full hover:bg-white/10 transition-colors text-white"
                title="Mes estimations"
              >
                <UserCircle className="h-5 w-5" />
              </Link>
            ) : (
              <div className="flex items-center space-x-3">
                <Link to="/login" className="btn btn-secondary" style={{ fontSize: 13, padding: '5px 12px' }}>Connexion</Link>
                <Link to="/register" className="btn bg-orange-500 hover:bg-orange-600 text-white" style={{ fontSize: 13, padding: '5px 12px' }}>Inscription</Link>
              </div>
            )}
          </div>

          {/* Mobile Menu Button */}
          <div className="flex items-center md:hidden">
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="text-white p-2 hover:bg-white/10 rounded-lg"
            >
              {isMenuOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      <div
        className={`fixed inset-0 bg-black/50 transition-opacity duration-300 md:hidden ${isMenuOpen ? 'opacity-100 z-40' : 'opacity-0 pointer-events-none'}`}
        onClick={() => setIsMenuOpen(false)}
      >
        <div
          className={`fixed right-0 top-12 bottom-0 w-80 bg-white shadow-xl transform transition-transform duration-300 ease-in-out ${isMenuOpen ? 'translate-x-0' : 'translate-x-full'}`}
          onClick={e => e.stopPropagation()}
        >
          <div className="p-6 space-y-6">
            {user && (
              <div className="flex items-center space-x-3 pb-4 border-b border-gray-200">
                <UserCircle className="h-8 w-8 text-primary" />
                <p className="font-medium text-gray-900">{user.email}</p>
              </div>
            )}

            <div className="flex flex-col space-y-6">
              <NavItems />

              {user ? (
                <div className="pt-4 border-t border-gray-200">
                  <Link
                    to="/dashboard"
                    className="flex items-center px-3 py-2 text-gray-700 hover:bg-gray-100 rounded-lg"
                    onClick={() => setIsMenuOpen(false)}
                  >
                    <CalculatorIcon className="h-5 w-5 mr-3 text-primary" />
                    Mes estimations
                  </Link>
                </div>
              ) : (
                <div className="space-y-4 pt-4 border-t border-gray-200">
                  <Link
                    to="/login"
                    className="flex items-center px-3 py-2 text-gray-700 hover:bg-gray-100 rounded-lg"
                    onClick={() => setIsMenuOpen(false)}
                  >
                    <LogIn className="h-5 w-5 mr-3 text-primary" />
                    Connexion
                  </Link>
                  <Link
                    to="/register"
                    className="flex items-center px-3 py-2 text-gray-700 hover:bg-gray-100 rounded-lg"
                    onClick={() => setIsMenuOpen(false)}
                  >
                    <UserPlus className="h-5 w-5 mr-3 text-primary" />
                    Inscription
                  </Link>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
